<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>
  
  <div contenido class="espacioTab">
      <div class="zonaBotones">
          <div class="menuexp">
            <mat-icon class="w3-zindex w3-button w3-dropdown-click" [ngStyle]="{'color':'gray'}"
              [matMenuTriggerFor]="menu2">more_vert</mat-icon>
          </div>
          <div class="botones">
            <div *appRoles="permisos.ADMINISTRACION">
              <button matTooltip="{{'gestion.formulacion.filosofiaCorporativa.agregElem'|translate}}"
                class="colorBotonDeNuevo" (click)="abrirFormAgregar(filosofias)">
                <mat-icon class="iconoMen">add_circle_outline</mat-icon>
                {{'gestion.formulacion.filosofiaCorporativa.agregElem' | translate}}
              </button>
            </div>
          </div>
      </div>
      <div class="zonaTarjetas">
        @if (viewTablero) {
        @for(filo of filosofias; track filo; let i = $index){
          <app-contenedor-elementos [header]="{ title: filo.name}" class="perspectivesZone">
            <mat-icon iconos *appRoles="permisos.ADMINISTRACION" [ngStyle]="{'color':'gray'}" class="w3-margin-right-contenido w3-dropdown-click"
              matTooltip="{{'gestion.formulacion.filosofiaCorporativa.tooltip1'|translate}}"
              (click)="abrirForm(filo)">edit</mat-icon>
            <mat-icon iconos *appRoles="permisos.ADMINISTRACION" [ngStyle]="{'color':'gray'}" class="w3-margin-right-contenido w3-dropdown-click"
              matTooltip="{{'gestion.formulacion.filosofiaCorporativa.tooltip2'|translate}}"
              (click)="eliminar(filo)">delete</mat-icon>
            
            <div body class="zonaInput">
              <mat-form-field appearance="outline" style="width: 95%;">
                <textarea matInput placeholder="Descripción" style="height:12vh;" value="{{filo.description}}"
                  disabled></textarea>
              </mat-form-field>
            </div>
          </app-contenedor-elementos>
        }
        }@else {
        @for (item of skeletons; track $index) {
        <div class="w3-row" style="height: 2vh; width: 98%;">
          <ngx-skeleton-loader count="1" [theme]="{
                                'border-radius': '10px',
                                height: '90%',
                                width: '28%',
                                margin: '4px 4px 4px 25px',
                                
                            }" />
        </div>
        <ngx-skeleton-loader count="1" [theme]="{
                            'border-radius': '10px',
                            height: '20vh',
                            width: '60vw',
                            margin: '25px 4px 4px 25px',
                            
                        }" />
        }
        }
      </div>
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modalEditar" [cerrar]="false" (close)="cerrarForm()">
  <div modal-header>
    {{'gestion.formulacion.filosofiaCorporativa.editarElem' | translate}}
  </div>

  <div modal-body>
    <form [formGroup]="formEdit" style="padding-right: 1.5vw;">
      <div class="inputDisp">
        @if (formEdit.hasError('isValid')) {
        <mat-error class="error-message">
          {{'gestion.formulacion.filosofiaCorporativa.formText1'|translate}} <strong>
            {{'gestion.formulacion.filosofiaCorporativa.formText2'|translate}}.</strong>
        </mat-error>
        }
        <div class="form-group">
          <label for="nombreedit" class="form-label">
            {{'gestion.formulacion.filosofiaCorporativa.formText3'|translate}}
          </label>
          <div style="display: inline-block; width: 100%;">
            <input id="nombreedit" formControlName="inputName" type="text" class="form-input anchosInputs"
            [matTooltip]="formEdit.controls.inputName.value" [appOverflowTooltip]="formEdit.controls.inputName.value"
              placeholder="{{'gestion.formulacion.filosofiaCorporativa.placeHolderNombre'|translate}}" required>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="descripcionedit"
          class="form-label">{{'gestion.formulacion.filosofiaCorporativa.formText6'|translate}}
          <span>*</span> </label>
        <div style="display: inline-block; width: 100%;">
          <textarea formControlName="inputDescription" id="descripcionedit" style="height: 20vh !important;"
          [matTooltip]="formEdit.controls.inputDescription.value" [appOverflowTooltip]="formEdit.controls.inputDescription.value"
            class="outline-textarea anchosInputs"></textarea>
        </div>
      </div>
    </form>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="cerrarForm()"
  />
  <app-button modal-footer
    [ngClass]="puede_guardarEdit()"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="alertas('editar')"
  />
</app-modal>

<app-modal [isOpen]="modalAgregar" [cerrar]="false" (close)="cerrarForm()">
  <div modal-header>
    {{'gestion.formulacion.filosofiaCorporativa.agregElem' | translate}}
  </div>
  <div modal-body>
    <form [formGroup]="formNuevo" style="padding-right: 1.5vw;">
      <div class="inputDisp">
        @if(formNuevo.hasError('isValid')){
        <mat-error class="error-message">
          {{'gestion.formulacion.filosofiaCorporativa.formText1'|translate}} <strong>
            {{'gestion.formulacion.filosofiaCorporativa.formText2'|translate}}.</strong>
        </mat-error>
        }
        <div class="form-group">
          <label for="nombre" class="form-label">
            {{'gestion.formulacion.filosofiaCorporativa.formText3'|translate}}
          </label>
          <div style="display: inline-block; width: 100%;">
            <input id="nombre" formControlName="inputName" type="text" class="form-input anchosInputs"
              [matTooltip]="formNuevo.controls.inputName.value" [appOverflowTooltip]="formNuevo.controls.inputName.value"
              placeholder="{{'gestion.formulacion.filosofiaCorporativa.placeHolderNombre'|translate}}" required>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label for="descripcion" class="form-label">{{'gestion.formulacion.filosofiaCorporativa.formText6'|translate}}
          <span>*</span> </label>
        <div style="display: inline-block; width: 100%;">
          <textarea formControlName="inputDescription" id="descripcion"
          [matTooltip]="formNuevo.controls.inputDescription.value" [appOverflowTooltip]="formNuevo.controls.inputDescription.value"
            class="outline-textarea anchosInputs"></textarea>
        </div>
      </div>
    </form>
  </div>
  
  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="cerrarForm()"
  />
  <app-button modal-footer
    [ngClass]="puede_guardar()"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="alertas('guardar')"
  />
</app-modal>

<mat-menu #menu2="matMenu">
  <button (click)="exportar_excel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
    <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
    <span>{{'gestion.formulacion.filosofiaCorporativa.export' | translate}}</span>
  </button>
</mat-menu>